@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
<div class="projectable-form-wrapper frontdoor-form"
  (keyup.enter)="save($event)"
  (keyup.escape)="closeModal(false)"
>
  <lib-form-header
    [data]="formData"
    [title]="isExistingEntity ? 'View Health Check: ' : 'Create New Health Check'"
    [moreActions]="moreActions"
    (actionRequested)="headerActionRequested($event)"
    [(formView)]="formView"
  ></lib-form-header>
  <div class="integration-form-container projectable-form-container">
    @if (formView === 'simple') {
      <div class="health-check-layout form-group-row">
        <div class="form-group-column full">
          <lib-form-field-container [title]="'Health Check Details'">
            <div class="stacked-fields">

              <div class="field-row" [class.frontdoor-error-field]="nameError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Name
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="nameError">
                      {{ nameErrorMessage || 'Must not be blank' }}
                    </span>
                  </span>
                </div>
                <input placeholder="Name your health check." [(ngModel)]="formData.name" />
              </div>

              <div class="field-row" [class.frontdoor-error-field]="shareIdError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Share
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="shareIdError">
                      {{ shareIdMessage || 'Select a share' }}
                    </span>
                  </span>
                </div>
                <app-filter-select
                  [options]="shares"
                  [(ngModel)]="formData.shareId"
                  placeholder="Select a Share"
                  optionValue="id"
                  optionLabel="name"
                ></app-filter-select>
              </div>

              <div class="field-row" [class.frontdoor-error-field]="endpointError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Endpoint
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="endpointError">
                      {{ endpointMessage || 'Enter an endpoint' }}
                    </span>
                  </span>
                </div>
                <input placeholder="Example: /status" [(ngModel)]="formData.endpoint" />
              </div>

              <div class="field-row" [class.frontdoor-error-field]="httpVerbError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    HTTP Method
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="httpVerbError">
                      {{ httpVerbMessage || 'Enter an HTTP method' }}
                    </span>
                  </span>
                </div>
                <input placeholder="Example: POST, GET, etc" [(ngModel)]="formData.httpVerb" />
              </div>

              <div class="field-pair">
                <div class="field-row" [class.frontdoor-error-field]="responseError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Expected HTTP Response
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="responseError">
                        {{ responseMessage || 'Enter a response code' }}
                      </span>
                    </span>
                  </div>
                  <input placeholder="Example: 200" type="number" [(ngModel)]="formData.expectedHttpResponse" />
                </div>
                <div class="field-row" [class.frontdoor-error-field]="timeoutError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Timeout (ms)
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="timeoutError">
                        {{ timeoutMessage || 'Enter a timeout value' }}
                      </span>
                    </span>
                  </div>
                  <input placeholder="Example: 1800" type="number" [(ngModel)]="formData.timeoutMilliseconds" />
                </div>
              </div>

            </div>
          </lib-form-field-container>
        </div>
      </div>
    }
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData"></lib-json-view>
        }
      </div>
    }
  </div>
</div>
